import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSession } from "@/context/SessionProvider";

export function useAuthGuard() {
    const navigate = useNavigate();
    const { user, loading } = useSession();

    useEffect(() => {
        if (loading) return;      // espera a que SessionProvider resuelva
        if (!user) navigate("/", { replace: true });
    }, [user, loading, navigate]);
}
